import { ENV } from './defaults';

export const LISTING_SEARCH_API_URL = ENV === 'dev' ? 'https://listings.realweb.com/wp-json/realweb-listings-addons_api/v1/listings/search' : '/wp-json/realweb-listings-addons_api/v1/listings/search';
export const LISTING_DETAILS_API_URL = ENV === 'dev' ? 'https://listings.realweb.com/wp-json/realweb-listings-addons_api/v1/listings/details' : '/wp-json/realweb-listings-addons_api/v1/listings/details';

export const RESULTS_SORT_OPTIONS = [
  { value: 'new', label: 'Newest' },
  { value: 'old', label: 'Oldest'},
  { value: 'priceDesc', label: 'Price (High to Low)'},
  { value: 'priceAsc', label: 'Price (Low to High)'},
  { value: 'bed', label: 'Bedrooms'},
  { value: 'bath', label: 'Bathrooms'},
  { value: 'sqft', label: 'Square Feet'},
  { value: 'lot', label: 'Lot Size'}
];

export const STATUS_OPTIONS = [
  { value: 'sale', label: 'For Sale', markerColor: '#ff0000'},
  { value: 'lease', label: 'For Lease', markerColor: '#00cc00' }
];

export const HOME_TYPE_OPTIONS = [
  { value: 'houses', label: 'Houses' },
  { value: 'townhomes', label: 'Townhomes' },
  { value: 'condo', label: 'Condos'},
  { value: 'multi', label: 'Multi-family'},
  { value: 'land', label: 'Lots/Land'},
  { value: 'apartments', label: 'Apartments'},
  { value: 'manufactured', label: 'Manufactured'}
];

export const BED_OPTIONS = [
  { value: '0', label: 'Studio' },
  { value: '1', label: '1'},
  { value: '1+1', label: '1+1'},
  { value: '2', label: '2'},
  { value: '2+1', label: '2+1'},
  { value: '3', label: '3'},
  { value: '4', label: '4'},
  { value: '5+', label: '5 +'}
];

export const BATH_OPTIONS = [
  { value: '', label: 'All'},
  { value: '1+', label: '1 +' },
  { value: '1.5+', label: '1.5 +'},
  { value: '2+', label: '2 +'},
  { value: '3+', label: '3 +'},
  { value: '4+', label: '4 +'}
];

export const PARKING_OPTIONS = [
  { value: 0, label: 'All' },
  { value: 1, label: '1 +' },
  { value: 2, label: '2 +'},
  { value: 3, label: '3 +'},
  { value: 4, label: '4 +'},
  { value: 5, label: '5 +'}
];

export const PRICE_RANGE_MIN = 0
export const PRICE_RANGE_MAX = 3000000;
export const PRICE_RANGE_STEP = 50000;
export const PRICE_RANGE_ULTD = PRICE_RANGE_MAX + PRICE_RANGE_STEP;

export const LEASE_PRICE_RANGE_MIN = 0
export const LEASE_PRICE_RANGE_MAX = 5000;
export const LEASE_PRICE_RANGE_STEP = 100;
export const LEASE_PRICE_RANGE_ULTD = LEASE_PRICE_RANGE_MAX + LEASE_PRICE_RANGE_STEP;

export const SIZE_RANGE_MIN = 0
export const SIZE_RANGE_MAX = 2500;
export const SIZE_RANGE_STEP = 100;
export const SIZE_RANGE_ULTD = SIZE_RANGE_MAX + SIZE_RANGE_STEP;

export const LOT_FRONTAGE_RANGE_MIN = 0
export const LOT_FRONTAGE_RANGE_MAX = 100;
export const LOT_FRONTAGE_RANGE_STEP = 5;
export const LOT_FRONTAGE_RANGE_ULTD = LOT_FRONTAGE_RANGE_MAX + LOT_FRONTAGE_RANGE_STEP;

export const MAP_SEARCH_DEFAULT_ZOOM = 12;

export const OPEN_HOUSE_OPTIONS = [
  { value: '', label: 'Unspecified' },
  { value: 'today', label: 'Today'},
  { value: 'tomorrow', label: 'Tomorrow'},
  { value: '7days', label: '7 Days'},
  { value: 'all', label: 'All'}
];

export const BASEMENT_OPTIONS = [
  { value: '', label: 'All' },
  { value: 'finished', label: 'Finished' },
  { value: 'seperateEntrance', label: 'Seperate Entrance'},
  { value: 'walkOut', label: 'Walk-out'}
];

export const DAYS_ON_MARKET_OPTIONS = [
  { value: '', label: 'All' },
  { value: '3', label: '< 3' },
  { value: '7', label: '< 7'},
  { value: '14', label: '< 14'},
  { value: '30', label: '< 30' }
];

export const _OPTIONS = [
  { value: '', label: '' },
  { value: '', label: ''},
];

export const DEFAULT_PAGE_SIZE = 50;